import { useSeoMeta } from "@unhead/react";
import type { FC } from "react";
import { useSelector } from "react-redux";
import { InfoPage } from "senf-atomic-design-system";
import useHandles from "../hooks/hooks";
import type { ClientState } from "../redux/reducers/dataReducer";

const ProjectInfoPage: FC = () => {
  const project = useSelector((state: ClientState) => state.data.project);
  const handle = useHandles(project.projectId, null, null);

  // Dynamic document title via Unhead (a11y + consistent head management)
  useSeoMeta({
    title: project?.title || "Senf.app",
    themeColor: project?.color,
  });

  return (
    <InfoPage
      // mode="view"
      project={project}
      handle={handle}
      className="h-screen w-screen"
    />
  );
};

export default ProjectInfoPage;
